// removed by extract-text-webpack-plugin
module.exports = {"AlertWrapper":"Alert-module__AlertWrapper__2_kS_","Alert":"Alert-module__Alert__1Sli5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Alert/Alert.module.css
// module id = 1698
// module chunks = 29